<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>淘宝</el-breadcrumb-item>
          <el-breadcrumb-item>商品订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" size="small" class="el-icon-circle-plus-outline" v-on:click="AddGroupBooking" >新增</el-button>
          </el-form-item>         
          <el-form-item >
            <el-input  placeholder="抢购名称" size="small" v-model="name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="trade_parent_id" fixed="left" label="单据号"> </el-table-column>
          <el-table-column  prop="tb_paid_time" label="付款时间"> </el-table-column>
          <el-table-column  prop="item_title" :show-overflow-tooltip="true"  label="标题"> </el-table-column>
          <el-table-column  prop="item_img" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.item_img"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.item_img"
                    width="400"
                    
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.item_img"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column>        
          <el-table-column  prop="item_num"  label="数量" ></el-table-column>
          <el-table-column  prop="item_price"  label="单价"> </el-table-column>
          <el-table-column  prop="alipay_total_price"  label="付款金额"> </el-table-column>
          <el-table-column  prop="tk_total_rate"  label="提成"> </el-table-column>
          <el-table-column  prop="pub_share_pre_fee"  label="结算预估收入" ></el-table-column>
          <el-table-column  prop="tk_earning_time"  label="佣金支付时间" ></el-table-column>
          <el-table-column  prop="tk_status"  label="状态" > 
            <template slot-scope="scope">                    
              <p v-if="scope.row.tk_status==-3">已取消</p>
              <p v-if="scope.row.tk_status==-2">申请取消</p>
              <p v-if="scope.row.tk_status==-1">未支付</p>
              <p v-if="scope.row.tk_status==0">支付完成</p>
              <p v-if="scope.row.tk_status==3">待使用</p>
              <p v-if="scope.row.tk_status==4">完成</p>
            </template>
          </el-table-column>        
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' tb_paid_time desc ',
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/taobao/Order',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.items
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },      
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>